/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminUavPlatform
 */
export interface InputAdminUavPlatform {
    /**
     * 
     * @type {string}
     * @memberof InputAdminUavPlatform
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    freqControlMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    freqVideoMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    maxDurationMin?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUavPlatform
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUavPlatform
     */
    speedKmh?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUavPlatform
     */
    type: InputAdminUavPlatformTypeEnum;
}


/**
 * @export
 */
export const InputAdminUavPlatformTypeEnum = {
    Recon: 'recon',
    Bomber: 'bomber',
    Kamikaze: 'kamikaze'
} as const;
export type InputAdminUavPlatformTypeEnum = typeof InputAdminUavPlatformTypeEnum[keyof typeof InputAdminUavPlatformTypeEnum];


/**
 * Check if a given object implements the InputAdminUavPlatform interface.
 */
export function instanceOfInputAdminUavPlatform(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function InputAdminUavPlatformFromJSON(json: any): InputAdminUavPlatform {
    return InputAdminUavPlatformFromJSONTyped(json, false);
}

export function InputAdminUavPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminUavPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'freqControlMhz': json['freqControlMhz'] == null ? undefined : json['freqControlMhz'],
        'freqVideoMhz': json['freqVideoMhz'] == null ? undefined : json['freqVideoMhz'],
        'maxDurationMin': json['maxDurationMin'] == null ? undefined : json['maxDurationMin'],
        'name': json['name'],
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
        'type': json['type'],
    };
}

export function InputAdminUavPlatformToJSON(value?: InputAdminUavPlatform | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'freqControlMhz': value['freqControlMhz'],
        'freqVideoMhz': value['freqVideoMhz'],
        'maxDurationMin': value['maxDurationMin'],
        'name': value['name'],
        'speedKmh': value['speedKmh'],
        'type': value['type'],
    };
}

